import { Component, OnInit } from '@angular/core';
import { Customer } from 'src/app/models/Customer';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-our-customers',
  templateUrl: './our-customers.component.html',
  styleUrls: ['./our-customers.component.css']
})
export class OurCustomersComponent implements OnInit {
  customers = new Array<Customer>();
  constructor(private service: ApiService) { }

  async ngOnInit() {
    this.customers = await this.service.getCustomers();
    this.customers.sort((a, b) => {
      return a.posizione - b.posizione;
    })
  }

  getCustomerImportant() {
    return this.customers.filter(a => a.image)
  }

  getCustomerMinor() {
    return this.customers.filter(a => !a.image)
  }
}
